import api from "../index";

export const GetNetProfitReportApi = () => api.get("MTFiveAccount/Get-Net-Profit-Report");
export const MTFiveAccountGetProfitBySymbolApi = () => api.get("MTFiveAccount/Get-Profit-By-Symbol");